import _asyncToGenerator from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ad35ea90"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header-info"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("已过期");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存");

import { computed, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { deductPrizeCount, getPrizeExpireList } from '@/request';
export default {
  name: 'DeductPrizeCountModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const loading = ref(false);
    const saving = ref(false);
    const tableData = ref([]);

    function formatPrice(price) {
      if (price === null || price === undefined || price === '') {
        return '-';
      }

      return Number(price).toFixed(2);
    }

    function formatNum(val) {
      if (val === null || val === undefined || val === '') {
        return '0';
      }

      return Number(val).toString();
    }

    function loadExpireList() {
      var _props$row;

      tableData.value = [];

      if (!((_props$row = props.row) !== null && _props$row !== void 0 && _props$row.merchandiseCansaleId)) {
        return;
      }

      loading.value = true;
      getPrizeExpireList({
        merchandiseCansaleId: props.row.merchandiseCansaleId,
        __warn: true
      }).then(data => {
        tableData.value = (data.rows || []).map(item => _objectSpread(_objectSpread({}, item), {}, {
          deductNum: undefined
        }));
      }).finally(() => {
        loading.value = false;
      });
    }

    function handleSave() {
      return _handleSave.apply(this, arguments);
    }

    function _handleSave() {
      _handleSave = _asyncToGenerator(function* () {
        if (saving.value) {
          return;
        }

        const items = tableData.value.filter(item => item.deductNum && Number(item.deductNum) > 0).map(item => ({
          cansaleExpireId: item.cansaleExpireId,
          deductNum: Number(item.deductNum)
        }));

        if (!items.length) {
          ElMessage.warning('请至少填写一行扣减数量');
          return;
        }

        for (const row of tableData.value) {
          const deduct = Number(row.deductNum || 0);

          if (deduct < 0) {
            ElMessage.warning('扣减数量不能为负数');
            return;
          }

          if (deduct > Number(row.leftNum || 0)) {
            ElMessage.warning('扣减数量不能大于剩余数量');
            return;
          }
        }

        saving.value = true;
        deductPrizeCount({
          merchandiseCansaleId: props.row.merchandiseCansaleId,
          items,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success(data.msg || '操作成功');
            visible.value = false;
            emit('success');
          }
        }).finally(() => {
          saving.value = false;
        });
      });
      return _handleSave.apply(this, arguments);
    }

    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "扣减数量",
        width: "860px",
        "destroy-on-close": "",
        onOpen: loadExpireList
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: saving.value,
          onClick: handleSave
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => {
          var _props$row2, _props$row3, _props$row4;

          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, "商品名称：" + _toDisplayString(((_props$row2 = __props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.prodName) || '-'), 1), _createElementVNode("span", null, "规格：" + _toDisplayString(((_props$row3 = __props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.prodSpecification) || '-'), 1), _createElementVNode("span", null, "价格：" + _toDisplayString(formatPrice((_props$row4 = __props.row) === null || _props$row4 === void 0 ? void 0 : _props$row4.price)), 1)]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: tableData.value,
            border: "",
            "max-height": "360"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "效期",
              "min-width": "140",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({
                row: item
              }) => [_createTextVNode(_toDisplayString(item.expireText || '-') + " ", 1), item.expired ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                type: "danger",
                size: "small",
                style: {
                  "margin-left": "6px"
                }
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "库存",
              width: "100"
            }, {
              default: _withCtx(({
                row: item
              }) => [_createTextVNode(_toDisplayString(formatNum(item.storageNumber)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "预占库存",
              width: "100"
            }, {
              default: _withCtx(({
                row: item
              }) => [_createTextVNode(_toDisplayString(formatNum(item.depositStorageNumber)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "剩余数量",
              width: "100"
            }, {
              default: _withCtx(({
                row: item
              }) => [_createTextVNode(_toDisplayString(formatNum(item.leftNum)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "扣减数量",
              width: "160"
            }, {
              default: _withCtx(({
                row: item
              }) => [_createVNode(_component_el_input_number, {
                modelValue: item.deductNum,
                "onUpdate:modelValue": $event => item.deductNum = $event,
                min: 0,
                max: Number(item.leftNum || 0),
                precision: 0,
                controls: true,
                style: {
                  "width": "130px"
                }
              }, null, 8, ["modelValue", "onUpdate:modelValue", "max"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, loading.value]])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};